import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, defineMessages } from 'react-intl';
import { Map, List } from 'immutable';
import { connect } from 'react-redux';
import axios from 'axios';
import { bindActionCreators } from 'redux';

import * as currentStatusActions from 'modules/currentStatus';
import * as userLib from 'libs/userLib';
import * as registerLib from 'libs/registerLib';
import * as validFunc from 'libs/validation';

import * as userActions from 'modules/user';
import * as loginActions from 'modules/login';

import { UserEditArea } from 'components';

import { getFormValues, isValid, reset } from 'redux-form';

class CtUser extends Component {
  constructor(props) {
    super(props);

    this.state = {
      loading: true,
      isClicked: false,
      errorMessage: { type: '', content: '' }
    };
  }

  componentDidMount() {
    this.getUser();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.needReload && nextProps.needReload !== this.props.needReload) {
      this.getUser();
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const { needReload, userInfo } = this.props;

    if (needReload || userInfo !== prevProps.userInfo) {
      this.getUser(true);
    }
  }

  // [비밀번호 모달] 열기/닫기
  onToggleModal = viewType => {
    // (태그 추가 모달) 초기화
    const { ReduxFormReset } = this.props;
    ReduxFormReset('formEditPassword');
    ReduxFormReset('formLeaveService');

    this.setState({ errorMessage: { type: '', content: '' } });

    const { CurrentStatusActions } = this.props;
    CurrentStatusActions.onToggleModal({ viewType: viewType });
  };

  // [비밀번호 모달] 비밀번호 변경 저장
  onSaveEditPassword = async () => {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const {
      userData,
      formEditPasswordStore,
      CurrentStatusActions,
      formEditPassword,
      isValidFormEditPassword
    } = this.props;

    if (isValidFormEditPassword) {
      this.setState({ isClicked: true });

      try {
        const param = {
          userEmailId: userData.userEmail.split('@')[0],
          userPasswd: formEditPassword.newPassword
        };
        const respObj = await registerLib.checkPasswordAPI(param);
        if (respObj && respObj.status && respObj.status === 200) {
          // 비밀번호 규칙 실패
          if (
            respObj.data &&
            Array.isArray(respObj.data.list) &&
            respObj.data.list[0].error &&
            !!respObj.data.list[0].error.bit
          ) {
            const { error } = respObj.data.list[0];
            this.setState({
              errorMessage: {
                type: 'newPassword',
                content: (
                  <span>
                    {validFunc.passwordVlidation(error).map((errorDetial, index) => {
                      return (
                        <span key={index} className="display-block mtb-5">
                          {errorDetial}
                        </span>
                      );
                    })}
                  </span>
                )
              }
            });

            this.setState({ isClicked: false });
            // 비밀번호 변경
          } else {
            if (formEditPassword.newPassword === formEditPassword.newPasswordAgain) {
              const param = {
                beforePasswd: formEditPassword.beforePassword,
                newPasswd: formEditPassword.newPassword
              };

              try {
                const respObj = await userLib.editPassword(param);
                if (respObj && respObj.status && respObj.status === 200) {
                  if (respObj.data && Array.isArray(respObj.data.list)) {
                    // 비밀번호 변경 성공
                    this.setState({ errorMessage: { type: '', content: '' } });

                    this.onToggleModal('');
                    this.onToggleSnackbar(
                      defineMessages(formatMessage({ id: 'CtUser_2', defaultMessage: '비밀번호가 변경 되었습니다.' }))
                    );
                  } else {
                    if (Array.isArray(respObj.data.error)) {
                      this.setState({
                        errorMessage: {
                          type: respObj.data.error[0].errCode === 1 ? 'beforePassword' : 'newPassword',
                          content: respObj.data.error[0].errInfo
                        }
                      });
                    } else {
                      // 비밀번호 틀림
                      this.setState({
                        errorMessage: {
                          type: 'beforePassword',
                          content: defineMessages(
                            formatMessage({ id: 'CtUser_3', defaultMessage: '비밀번호가 틀렸습니다.' })
                          )
                        }
                      });
                    }
                  }
                } else {
                  // 응답 오류
                }

                this.setState({ isClicked: false });
              } catch (e) {
                console.log(e);
              }
            } else {
              this.setState({
                errorMessage: {
                  type: 'newPasswordAgain',
                  content: defineMessages(
                    formatMessage({ id: 'CtUser_4', defaultMessage: '비밀번호가 일치 하지 않습니다' })
                  )
                }
              });
              this.setState({ isClicked: false });
            }
          }
        } else {
          // 응답 오류
        }
      } catch (e) {
        console.log(e);
      }
    }
  };

  // 탈퇴 하기
  onLeaveService = async () => {
    // 국제화 처리
    const { formatMessage } = this.props.intl;
    const { formLeaveServiceStore, formLeaveService, isValidFormLeaveService } = this.props;

    if (isValidFormLeaveService) {
      this.setState({ isClicked: true });

      const param = {
        userPasswd: formLeaveService.userPassword
      };

      try {
        const respObj = await axios({method: 'delete', url: '/api/v1/User', ['data']: param});
        if (respObj && respObj.status && respObj.status === 200) {
          if (respObj.data && Array.isArray(respObj.data.list)) {
            // 로그아웃 처리
            const { UserActions, LoginActions } = this.props;
            // 로그아웃 처리
            UserActions.logout();
            // 로그인 초기화
            LoginActions.setInitial();
          } else {
            this.setState({
              errorMessage: {
                type: 'userPassword',
                content: defineMessages(formatMessage({ id: 'CtUser_3', defaultMessage: '비밀번호가 틀렸습니다.' }))
              }
            });
          }
        } else {
          // 응답 오류
        }

        this.setState({ isClicked: false });
      } catch (e) {
        console.log(e);
      }
    }
  };

  // 성공 실패시 알림창
  onToggleSnackbar = message => {
    const { CurrentStatusActions } = this.props;
    setTimeout(() => {
      CurrentStatusActions.toggleSnackbar({ message: '' });
    }, 5000);

    CurrentStatusActions.toggleSnackbar({ message });
  };

  // 사용자 정보 get
  getUser = async () => {
    if (!this.state.loading) {
      this.setState({ loading: true });

      try {
        const { UserActions } = this.props;
        await UserActions.getUser();
      } catch (e) {
        console.log(e);
      }

      this.setState({ loading: false });
    }
  };

  render() {
    const { loading } = this.state;
    const { userData, isModal } = this.props;

    const {
      // 비밀번호 변경 모달
      onSaveEditPassword,
      // 탈퇴
      onLeaveService,
      onToggleModal
    } = this;

    return (
      <UserEditArea
        userInfo={userData}
        loading={loading}
        isModal={isModal}
        isClicked={this.state.isClicked}
        editPasswordData={{
          errorMessage: this.state.errorMessage,
          onSaveEditPassword: onSaveEditPassword,
          onToggleModal: onToggleModal
        }}
        leaveServiceData={{
          errorMessage: this.state.errorMessage,
          onLeaveService: onLeaveService,
          onToggleModal: onToggleModal
        }}
      />
    );
  }
}

CtUser.propTypes = {};
CtUser.defaultProps = {};

const mapStateToProps = state => ({
  isModal: state.currentStatus.get('isModal'),
  userData: state.user.get('user'),
  needReload: state.user.get('needReload'),
  formEditPasswordStore: state.form['formEditPassword'],
  formLeaveServiceStore: state.form['formLeaveService'],
  formEditPassword: getFormValues('formEditPassword')(state),
  formLeaveService: getFormValues('formLeaveService')(state),
  isValidFormEditPassword: isValid('formEditPassword')(state),
  isValidFormLeaveService: isValid('formLeaveService')(state)
});

const mapDispatchToProps = dispatch => ({
  LoginActions: bindActionCreators(loginActions, dispatch),
  UserActions: bindActionCreators(userActions, dispatch),
  CurrentStatusActions: bindActionCreators(currentStatusActions, dispatch),
  ReduxFormReset: bindActionCreators(reset, dispatch)
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(CtUser));



// WEBPACK FOOTER //
// ./src/script/containers/user/CtUser.js